module.exports = new __parcel__URL__("empty-state.ac8102dc.svg").toString();